import { ChangeEvent, CSSProperties, ReactElement, useState } from "react";
// import { IParentSize } from "../../../types";
import FilterComponentBase from "../../../components/filterComponentBase";
import { useFetch } from "../../../system/useFetch";
import { useSelector } from "react-redux";
import { IFilterData, IParentSize, IState } from "../../../types";
import SkeletonView from "../../../components/skeletonView";
import { Alert, FormControl, Select, InputLabel, MenuItem, IconButton, Tooltip, Tab, Tabs  } from "@mui/material";
import { IReportTreeNode, Reference, TreeStructure } from "./types";
import { Download } from "@mui/icons-material";
import { saveBlobAs } from "../../../system/utils";
import TableComponent from "./components/tableComponent";
import ChartsComponents from "./components/chartsComponents";
// import TabPanel from "../../../components/tabPanel";

interface IProps {
  parentSize: IParentSize;
}

const gridStyle: CSSProperties = {
  position: "relative",
  // ...parentSize,
  gridTemplateRows: "auto auto 1fr",
  gridTemplateColumns: "1fr",
  alignItems: "stretch"
};

const GroupByItems = [
  {
    value: "heatNumber",
    title: "Heat Number",
  },
  {
    value : "factoryDay",
    title : "Factory Day"
  },
  {
    value: "monthNumber",
    title: "Monthly"
  },
  {
    value : "shiftName",
    title : "Shift"
  }
];

const ReportPage = ({ parentSize }: IProps): ReactElement => {
  const darkMode = useSelector((state: IState) => state.darkMode);
  const filter = useSelector<IState, IFilterData>(state => state.filter);
  const [ groupBy, setGroupBy ] = useState("heatNumber");
  const [ selectedTab, setSelectedTab ] = useState(0);
  const { data, loading, error } = useFetch<Record<string, number>[]>(
    {
      module: "meltShop",
      query: "getReport",
      payload: { ...filter.remote, groupBy }
    });

  const contentSize = { ...parentSize, height: parentSize.height - 116 };

  const onExport = () => {
    let fileContent = "";

    const readNode = (node: IReportTreeNode, level: number) => {
      if (node.children) {
        node.children.forEach(n => {
          if (level >= 0) {
            fileContent += `${" ".repeat(level)}${n.title}\t`;
            fileContent += `${n.unit}\t`;
          } else {
            fileContent += "\t\t";
          }

          data?.forEach(d  => {
            fileContent += `${d[n.field ?? n.title] ?? "---"}\t`;
          });

          fileContent += "\n";

          readNode(n, level + 1);
        });
      }
    };

    readNode(Reference, -1);
    readNode(TreeStructure, 0);

    const file = new Blob([ fileContent ], { type: "text/csv" });
    saveBlobAs(URL.createObjectURL(file), "meltshop-report.csv");
  };

  const handleChange = (_event: ChangeEvent<any>, newValue: number) => {
    setSelectedTab(newValue);
  };

  return (
    <div className="display-grid" style={gridStyle}>
      <FilterComponentBase loading={loading} customFilter={{ "Group By": groupBy }}
        toolbar={
          <Tooltip title={"Export"}>
            <IconButton color="primary" onClick={onExport}>
              <Download/>
            </IconButton>
          </Tooltip>
        }>
        <FormControl className="ml-1 form-control">
          <InputLabel id="demo-simple-select-label">Group By</InputLabel>
          <Select
            variant="standard"
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={groupBy}
            displayEmpty={true}
            onChange={(event) => setGroupBy(event.target.value)}>
            {GroupByItems.map(r => <MenuItem key={r.value} value={r.value}>{r.title}</MenuItem>)}
          </Select>
        </FormControl>
      </FilterComponentBase>
      {loading && <SkeletonView  parentSize={parentSize}/>}
      {error && <Alert severity="warning">{error.message}</Alert>}
      {!loading && !error && !data && <Alert severity="warning">No Data to Display.</Alert>}

      { data &&
        <>
          <Tabs
            value={selectedTab}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            centered={true}
            style={{ background: darkMode ? "rgba(255, 255, 255, 0.2)" : "rgba(0, 0, 0, 0.2)" }}>
            <Tab label="General"/>
            <Tab label="Charts"/>
          </Tabs>

          <TableComponent hidden={selectedTab !== 0} data={data} parentSize={contentSize} />

          <ChartsComponents hidden={selectedTab !== 1} data={data} parentSize={contentSize} />
        </>
      }
    </div>
  );
};

export default ReportPage;